import { render, staticRenderFns } from "./Importa.vue?vue&type=template&id=873e9480&scoped=true"
import script from "./Importa.vue?vue&type=script&lang=js"
export * from "./Importa.vue?vue&type=script&lang=js"
import style0 from "./Importa.vue?vue&type=style&index=0&id=873e9480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873e9480",
  null
  
)

export default component.exports